/** Keep legacy single-value URLs and canonicalize multiple values for shared caches. */
export function selectedFilterValues(value?: string): string[] {
  return [
    ...new Set(
      (value ?? "")
        .split(",")
        .map(item => item.trim())
        .filter(Boolean),
    ),
  ].sort()
}

export function toggleFilterValue(value: string | undefined, option: string): string {
  const selected = new Set(selectedFilterValues(value))
  if (selected.has(option)) selected.delete(option)
  else selected.add(option)
  return [...selected].sort().join(",")
}
